import React, { useState } from 'react';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import { Box, Button, Flex, Icon, PopoverBody, PopoverHeader, Text, VStack } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import {
  BusinessTypeIndustriesDisplayNames,
  BusinessTypesByIndustry
} from '../../constants/businessTypes';
import colors from '../../styles/theme/foundation/colors';
import { buttonItemStyle } from '../../styles/theme/util/popoverMenuButtonStyles';
import SearchInputGroup from '../SearchInputGroup';

const Content = ({ onChange, defaultValue }) => {
  const [selectedIndustry, setIndustry] = useState(null);
  const [items, setItems] = useState([]);

  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = evt => {
    const searchValue = (evt.target.value).toLowerCase();

    const filtered = BusinessTypesByIndustry[selectedIndustry]
      .filter(b => b.text.toLowerCase().includes(searchValue));

    setItems(filtered);
    setSearchTerm(searchValue);
  };

  const handleBusinessTypeSelect = evt => {
    if (evt.target.value !== defaultValue) {
      onChange(evt.target.value);
    }
  };

  if (selectedIndustry) {
    return (
      <>
        <PopoverHeader alignItems="center" as={Flex} justifyContent="space-between" px={2} py={3}>
          <Button
            leftIcon={<Icon as={BsChevronLeft} />}
            size="xs"
            variant="textPrimary"
            onClick={() => {
              setIndustry(null);
              setItems([]);
              setSearchTerm([]);
            }}
          >
            {BusinessTypeIndustriesDisplayNames[selectedIndustry]}
          </Button>
        </PopoverHeader>
        <PopoverBody width="400px">
          <Box my={2}>
            <SearchInputGroup
              searchTerm={searchTerm}
              variant="primary"
              onChange={handleSearch}
            />
          </Box>
          {items.map(businessType => (
            <Button
              _hover={buttonItemStyle.hover}
              id={businessType.value}
              key={businessType.value}
              overflow="hidden"
              padding="10px 14px"
              style={buttonItemStyle}
              textOverflow="ellipsis"
              value={businessType.value}
              variant="unstyled"
              whiteSpace="nowrap"
              width="100%"
              onClick={handleBusinessTypeSelect}
            >
              {businessType.text}
            </Button>
          ))}
        </PopoverBody>
      </>
    );
  }

  return (
    <PopoverBody color={colors.greyScale['600']} textStyle="bodyMd500" width="400px">
      {Object.keys(BusinessTypesByIndustry).map(ind => (
        <Flex
          _hover={buttonItemStyle.hover}
          alignItems="center"
          justifyContent="space-between"
          padding="10px 14px"
          width="100%"
          onClick={() => {
            setIndustry(ind);
            setItems(BusinessTypesByIndustry[ind]);
          }}
        >
          <Text>{BusinessTypeIndustriesDisplayNames[ind]}</Text>
          <Icon as={BsChevronRight} />
        </Flex>
      ))}
    </PopoverBody>
  );
};

Content.propTypes = {
  onChange: PropTypes.func,
  defaultValue: PropTypes.string
};

export default Content;
